export class Forgot {
    email:string ="";
    constructor(email:string ){
        this.email = email;
}
}
